import React from 'react';
import { useIdleTimer } from 'react-idle-timer';
import { IdleReset } from './IdleReset';

const SECONDS = 60*5;

export const IdleTimerConfirmation = React.memo(() => {
    const [remaining, setRemaining] = React.useState(SECONDS);

    const onIdle = () => {
        setRemaining(0);
    };

    const onActive = () => {
        setRemaining(SECONDS);
    };

    const { getRemainingTime, activate } = useIdleTimer({
        onIdle,
        onActive,
        timeout: 1000 * SECONDS,
        throttle: 500,
        stopOnIdle: true,
        crossTab: true,
        syncTimers: 200
    });

    React.useEffect(() => {
        const interval = setInterval(() => {
            const time = Math.ceil(getRemainingTime() / 1000);
            setRemaining(time);
        }, 500);

        return () => clearInterval(interval);
    }, [getRemainingTime]);

    const handleKeepAlive = () => {
        activate();
        setRemaining(SECONDS);
    };

    return (
        (remaining <= 0) && <IdleReset handleKeepAlive={handleKeepAlive} active={activate} />
    );
});
